var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoutai(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34631322",
    x: 3.53125,
    y: 3.0625,
    width: 9.9375,
    height: 9.87549,
    fill: "#C2C2C2",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34631319",
    x: 1.71875,
    y: 1.9375,
    width: 13.5625,
    height: 2.125,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34631320",
    x: 1.71875,
    y: 6.9375,
    width: 13.5625,
    height: 2.125,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34631321",
    x: 1.71875,
    y: 11.9375,
    width: 13.5625,
    height: 2.125,
    fill: "white",
    stroke: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoutai);
export default __webpack_public_path__ + "static/media/loutai.6d2fc076f6a4c84331d12523edef3198.svg";
export { ForwardRef as ReactComponent };